import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, ArrowLeft } from 'lucide-react';
import { Logo } from '../components/Logo';

// Schedule helper — returns true if article is published (publishDate is today or earlier)
const isPublished = (publishDate) => {
  if (!publishDate) return true;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return new Date(publishDate) <= today;
};

const blogArticles = [
  {
    slug: "best-2bhk-flats-rahatani-under-75-lakhs",
    title: "Best 2 BHK Flats in Rahatani Under ₹75 Lakhs",
    excerpt: "Rahatani offers some of Pune's best-value 2 BHK apartments. Here's what smart buyers need to know about pricing, location advantages, and the best projects to consider.",
    date: "Feb 2026",
    publishDate: "2026-02-05",
    readTime: "5 min read",
    category: "Buying Guide",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&auto=format&fit=crop&q=80",
    imageAlt: "Home keys handover for 2 BHK flat in Rahatani Pune under 75 lakhs"
  },
  {
    slug: "rahatani-vs-wakad-home-buyers-2026",
    title: "Rahatani vs Wakad — Which is Better for Home Buyers?",
    excerpt: "Two of Pune's most popular residential areas compared head-to-head. We break down prices, connectivity, lifestyle, and investment potential to help you decide.",
    date: "Feb 2026",
    publishDate: "2026-02-12",
    readTime: "6 min read",
    category: "Market Insights",
    image: "https://images.unsplash.com/photo-1572252009286-268acec5ca0a?w=800&auto=format&fit=crop&q=80",
    imageAlt: "Pune residential skyline comparison Rahatani vs Wakad home buyers 2026"
  },
  {
    slug: "why-rahatani-pune-smartest-investment-2026",
    title: "Why Rahatani is the Smartest Real Estate Investment in 2026",
    excerpt: "With metro connectivity, BRTS expansion, and proximity to Hinjewadi IT Park — Rahatani's property market is poised for significant growth. Here's the complete analysis.",
    date: "Feb 2026",
    publishDate: "2026-02-19",
    readTime: "7 min read",
    category: "Investment",
    image: "https://images.unsplash.com/photo-1579621970795-87facc2f976d?w=800&auto=format&fit=crop&q=80",
    imageAlt: "Indian rupee notes stacked — Rahatani Pune real estate investment growth analysis 2026"
  },
  {
    slug: "upcoming-metro-stations-near-rahatani-pune",
    title: "Upcoming Metro Stations Near Rahatani — What It Means for Property Prices",
    excerpt: "Pune Metro Phase 2 is set to transform Rahatani's connectivity. Here's a complete guide to the nearest stations, timelines, and how it impacts property values.",
    date: "Feb 2026",
    publishDate: "2026-02-26",
    readTime: "6 min read",
    category: "Infrastructure",
    image: "https://images.unsplash.com/photo-1663057642709-b0b8765eee3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxwdW5lJTIwbWV0cm8lMjB0cmFpbiUyMHN0YXRpb24lMjBpbmRpYXxlbnwwfHx8fDE3NzcxOTgxMjh8MA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Pune Metro Phase 2 train station — upcoming metro stations near Rahatani"
  },
  {
    slug: "stamp-duty-registration-charges-pune-2026",
    title: "Stamp Duty & Registration Charges in Pune 2026 — Complete Calculator Guide",
    excerpt: "Everything you need to know about stamp duty rates, registration fees, GST, and total cost of buying a flat in Pune. Includes a simple cost breakdown calculator.",
    date: "Mar 2026",
    publishDate: "2026-03-05",
    readTime: "5 min read",
    category: "Buying Guide",
    image: "https://images.unsplash.com/photo-1565371768838-2479eb537a78?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxzdGFtcCUyMGR1dHklMjBkb2N1bWVudCUyMHByb3BlcnR5JTIwcmVnaXN0cmF0aW9uJTIwaW5kaWF8ZW58MHx8fHwxNzc3MTk4MTI4fDA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Reserve Bank of India currency notes — stamp duty and registration charges in Pune 2026"
  },
  {
    slug: "pmay-subsidy-2bhk-pune-2026",
    title: "PMAY Subsidy for 2 BHK in Pune 2026 — Eligibility & How to Apply",
    excerpt: "Complete guide to Pradhan Mantri Awas Yojana subsidy for home buyers in Pune. Check eligibility, subsidy amount, and how to apply.",
    date: "Mar 2026",
    publishDate: "2026-03-12",
    readTime: "5 min read",
    category: "Government Scheme",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=800&auto=format&fit=crop&q=80",
    imageAlt: "Warm modest home exterior — PMAY subsidy for first-time 2 BHK home buyers in Pune 2026"
  },
  {
    slug: "home-loan-emi-calculator-75-lakh-pune",
    title: "Home Loan EMI for ₹75 Lakh Flat in Pune — Monthly Payment Breakdown",
    excerpt: "Calculate your monthly EMI for a ₹75 Lakh flat in Pune. Compare bank rates and see exact monthly costs for different tenures.",
    date: "Mar 2026",
    publishDate: "2026-03-19",
    readTime: "4 min read",
    category: "Finance",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&auto=format&fit=crop&q=80",
    imageAlt: "Calculator and financial planning — home loan EMI calculator for ₹75 Lakh flat in Pune"
  },
  {
    slug: "top-schools-near-rahatani-pune",
    title: "Top 10 Schools Near Rahatani, Pune — A Parent's Complete Guide",
    excerpt: "Complete list of the best CBSE, ICSE & SSC schools near Rahatani with fees, boards, and distances. Essential reading for families.",
    date: "Mar 2026",
    publishDate: "2026-03-26",
    readTime: "6 min read",
    category: "Neighbourhood",
    image: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=800&auto=format&fit=crop&q=80",
    imageAlt: "Top schools near Rahatani Pune — CBSE ICSE SSC classroom learning environment"
  },
  {
    slug: "rahatani-area-guide-pune",
    title: "Rahatani Area Guide — Pin Code, Map, Connectivity & Neighbourhood Overview",
    excerpt: "Complete Rahatani area guide covering pin code 411017, BRTS, metro, hospitals, malls, restaurants, and property rates.",
    date: "Apr 2026",
    publishDate: "2026-04-02",
    readTime: "5 min read",
    category: "Area Guide",
    image: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=800&auto=format&fit=crop&q=80",
    imageAlt: "Couple reviewing home plans together — Rahatani Pune area guide pin code 411017 connectivity"
  },
  {
    slug: "rera-verified-projects-rahatani-pune",
    title: "RERA Verified Projects in Rahatani, Pune 2026 — Why It Matters",
    excerpt: "Why RERA registration is crucial when buying a flat. How to verify on MahaRERA and what it protects you against.",
    date: "Apr 2026",
    publishDate: "2026-04-09",
    readTime: "4 min read",
    category: "Legal",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&auto=format&fit=crop&q=80",
    imageAlt: "Property legal documents — RERA verified projects in Rahatani Pune 2026"
  },
  {
    slug: "3bhk-flats-rahatani-under-1-crore",
    title: "Best 3 BHK Flats in Rahatani Under ₹1 Crore — Top Options 2026",
    excerpt: "Looking for a spacious 3 BHK under ₹1 Crore? Compare the best projects, carpet areas, amenities, and prices in Rahatani.",
    date: "Apr 2026",
    publishDate: "2026-04-16",
    readTime: "5 min read",
    category: "Buying Guide",
    image: "https://images.unsplash.com/photo-1513694203232-719a280e022f?w=800&auto=format&fit=crop&q=80",
    imageAlt: "Cozy family living room with warm lighting — 3 BHK flats in Rahatani Pune under ₹1 crore"
  },
  {
    slug: "hinjewadi-professionals-choosing-rahatani",
    title: "Why Hinjewadi Professionals are Choosing Rahatani over Phase 1 & 2",
    excerpt: "Tired of the Hinjewadi traffic? IT professionals are quietly making a smarter move. Discover why Rahatani — with seamless BRTS commute, 25-35% better value, and WFH-ready 2 & 3 BHK flats — is winning.",
    date: "Apr 2026",
    publishDate: "2026-04-29",
    readTime: "6 min read",
    category: "Lifestyle",
    image: "https://images.unsplash.com/photo-1587614382346-4ec70e388b28?w=800&auto=format&fit=crop&q=80",
    imageAlt: "IT professional working from home on laptop — Hinjewadi commuter choosing peaceful Rahatani lifestyle over Phase 1 and 2"
  },
  {
    slug: "carpet-area-vs-built-up-vs-super-built-up-pune",
    title: "Carpet Area vs Built-Up Area vs Super Built-Up — A Pune Buyer's Guide",
    excerpt: "Three numbers, one flat. Learn what carpet area, built-up area, and super built-up area really mean — plus the RERA rule, the loading factor math, and a worked Pune example that shows how to compare quotes apples-to-apples.",
    date: "Apr 2026",
    publishDate: "2026-04-30",
    readTime: "6 min read",
    category: "Buying Guide",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&auto=format&fit=crop&q=80",
    imageAlt: "Architectural floor plan with tape measure — carpet area vs built-up area vs super built-up area Pune"
  }
];

const BlogPage = () => {
  useEffect(() => {
    document.title = "Real Estate Insights — Rahatani, Pune | Nova Homes Blog";
  }, []);

  return (
    <div data-testid="blog-page" className="min-h-screen bg-[#F7F5F0]">
      {/* Header */}
      <header className="bg-[#111111] py-4 px-4 md:px-8 lg:px-16 flex items-center justify-between">
        <div className="flex items-center gap-5">
          <Link to="/">
            <Logo variant="light" />
          </Link>
          <span className="text-white/20 text-sm hidden md:inline">|</span>
          <span className="text-white/50 text-sm font-light tracking-wide hidden md:inline">Insights</span>
        </div>
        <Link
          to="/"
          data-testid="blog-back-home"
          className="flex items-center gap-1.5 text-white/40 hover:text-white/70 text-sm font-light transition-colors"
        >
          <ArrowLeft size={15} />
          Back to Home
        </Link>
      </header>

      {/* Hero */}
      <section className="py-16 md:py-24 text-center px-4">
        <p className="text-[#C5A46D] text-[10px] uppercase tracking-[0.5em] mb-4 font-medium">Nova Homes Insights</p>
        <h1 className="font-heading text-4xl md:text-5xl text-[#111] font-semibold mb-4">
          Real Estate Knowledge
        </h1>
        <p className="text-[#666] text-base md:text-lg font-light max-w-xl mx-auto">
          Honest market insights, buying guides, and investment analysis for Pune home buyers.
        </p>
      </section>

      {/* Articles Grid */}
      <section className="pb-24 px-4 md:px-8 lg:px-16">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {blogArticles
            .filter((article) => isPublished(article.publishDate))
            .sort((a, b) => new Date(b.publishDate || 0) - new Date(a.publishDate || 0))
            .map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              data-testid={`blog-card-${article.slug}`}
              className="group bg-white border border-[#111]/[0.06] hover:border-[#C5A46D]/30 transition-all duration-300 hover:shadow-lg"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.imageAlt || article.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-[#C5A46D] text-[10px] uppercase tracking-[0.2em] font-medium">{article.category}</span>
                  <span className="text-[#999] text-[10px]">·</span>
                  <span className="flex items-center gap-1 text-[#999] text-[10px]">
                    <Clock size={10} />
                    {article.readTime}
                  </span>
                </div>
                <h2 className="font-heading text-lg md:text-xl text-[#111] font-semibold mb-3 group-hover:text-[#C5A46D] transition-colors leading-tight">
                  {article.title}
                </h2>
                <p className="text-[#666] text-sm font-light leading-relaxed mb-4">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 text-[#C5A46D] text-sm font-medium group-hover:gap-3 transition-all">
                  Read More <ArrowRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 bg-[#111111] text-center">
        <Logo variant="light" className="justify-center mb-3" />
        <p className="text-white/20 text-sm font-light tracking-wide">
          © 2025 Nova Homes | Pune, Maharashtra
        </p>
      </footer>
    </div>
  );
};

export default BlogPage;
